import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { LEGAL_UPDATED } from "@/lib/legalContent";

export default function LegalLayout({ title, intro, children }) {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-24">
        <section className="section-soft border-b border-border">
          <div className="mx-auto max-w-4xl px-5 py-12 lg:px-8 lg:py-16">
            <nav className="mb-5 flex items-center gap-1.5 text-xs font-semibold text-muted-foreground">
              <Link to="/" className="hover:text-primary">Inicio</Link>
              <ChevronRight className="h-3.5 w-3.5" />
              <span className="text-foreground">{title}</span>
            </nav>
            <h1 className="font-display text-4xl font-semibold text-foreground sm:text-5xl">{title}</h1>
            {intro && <p className="mt-4 max-w-2xl text-base leading-relaxed text-muted-foreground">{intro}</p>}
            <p className="mt-4 text-xs font-medium uppercase tracking-wide text-muted-foreground">
              Última actualización: {LEGAL_UPDATED}
            </p>
          </div>
        </section>

        <section className="mx-auto max-w-4xl px-5 py-12 lg:px-8 lg:py-16">
          <div className="legal-prose space-y-8 text-[15px] leading-relaxed text-foreground/85">
            {children}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

export const LegalSection = ({ heading, children }) => (
  <div className="space-y-3">
    {heading && <h2 className="font-display text-2xl font-semibold text-foreground">{heading}</h2>}
    {children}
  </div>
);
